const Helper = {
  dgraphQUrl: "",
  token: "",
  sendToViator(detail: any) {
    const viatorDiv = document.getElementById("viatorDiv")!;
    //* const event = document.createEvent("Event");

    debugger;

    const event = new CustomEvent("viator", {
      bubbles: true,
      detail: {
        ...detail,
        ...{ token: Helper.token, dgraphQUrl: Helper.dgraphQUrl },
      },
    });

    if (viatorDiv) {
      const cancelled = !viatorDiv.dispatchEvent(event);

      if (!cancelled) {
        //alert("Got")
      }
    }
  },

  sendToViatorPromise(route: string, props: any = {}) {
    return new Promise<any>((resolve, reject) => {
      debugger;
      const viatorDiv = document.getElementById("viatorDiv")!;
      const event = new CustomEvent("viator", {
        bubbles: true,
        detail: {
          token: Helper.token,
          dgraphQUrl: Helper.dgraphQUrl,
          route: route,
          props: {
            ...props,
            onResolve: (data: any) => resolve(data),
            onReject: (err: any) => reject(err),
          },
        },
      });

      if (viatorDiv) {
        const cancelled = !viatorDiv.dispatchEvent(event);

        if (cancelled) {
          reject({
            message: "Cancelled",
          });
        }
      } else {
        // reject({
        //     message: "Div not found"
        // });
      }
    });
  },

  sendToExpediaPromise(route: string, props: any = {}) {
    return new Promise<any>((resolve, reject) => {
      //const expediaDiv = document.getElementById("expediaDiv")!;
      const expediaDiv = document.getElementById("viatorDiv")!;
      //const event = new CustomEvent("expedia", {
      const event = new CustomEvent("viator", {
        bubbles: true,
        detail: {
          token: Helper.token,
          dgraphQUrl: Helper.dgraphQUrl,
          route: route,
          props: {
            ...props,
            onResolve: (data: any) => resolve(data),
            onReject: (err: any) => reject(err),
          },
        },
      });

      if (expediaDiv) {
        const cancelled = !expediaDiv.dispatchEvent(event);

        if (cancelled) {
          reject({
            message: "Cancelled",
          });
        }
      } else {
        // reject({
        //     message: "Div not found"
        // });
      }
    });
  },

  sendToPaymentPromise(route: string, props: any = {}) {
    return new Promise<any>((resolve, reject) => {
      //const expediaDiv = document.getElementById("expediaDiv")!;
      const expediaDiv = document.getElementById("viatorDiv")!;
      //const event = new CustomEvent("expedia", {
      const event = new CustomEvent("viator", {
        bubbles: true,
        detail: {
          token: Helper.token,
          dgraphQUrl: Helper.dgraphQUrl,
          route: route,
          props: {
            ...props,
            onResolve: (data: any) => resolve(data),
            onReject: (err: any) => reject(err),
          },
        },
      });

      if (expediaDiv) {
        const cancelled = !expediaDiv.dispatchEvent(event);

        if (cancelled) {
          reject({
            message: "Cancelled",
          });
        }
      } else {
        // reject({
        //     message: "Div not found"
        // });
      }
    });
  },

  TimeConverter(dateTimeString: string) {
    if (!dateTimeString) {
      return null;
    }

    const formattedDateTimeString = dateTimeString.replace(' GMT+0000', '');
    const dateTime = new Date(formattedDateTimeString);
    const hours = dateTime.getHours();


    const minutes = dateTime.getMinutes();
    const period = hours >= 12 ? 'PM' : 'AM';
    const twelveHourFormat = ((hours + 11) % 12 + 1) + ':' + (minutes < 10 ? '0' : '') + minutes + ' ' + period;
    return twelveHourFormat;
  },

  convertDecimalTime(decimalTime: any) {
    if (!decimalTime) {
      return null;
    }

    const hours = Math.floor(decimalTime);
    const minutes = Math.round((decimalTime - hours) * 60);

    let result = '';
    if (hours > 0) {
        result += hours === 1 ? '1 hour' : `${hours} hours`;
    }

    if (minutes > 0) {
        result += hours > 0 ? ' and ' : '';
        result += minutes === 1 ? '1 minute' : `${minutes} minutes`;
    }

    return result;
  }
};

export default Helper;
